import { createRouter, createWebHistory } from 'vue-router'
import ProjectDetailsView from '../views/ProjectDetailsView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/EmptyView.vue'),
      meta: { section: 'home' }
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('../views/EmptyView.vue'),
      meta: { section: 'about' }
    },
    {
      path: '/projects',
      name: 'projects',
      component: () => import('../views/EmptyView.vue'),
      meta: { section: 'projects' }
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('../views/EmptyView.vue'),
      meta: { section: 'contact' }
    },
    {
      path: '/projects/:id',
      name: 'project-details',
      components: {
        default: () => import('../views/EmptyView.vue'),
        'project-details': ProjectDetailsView
      },
      props: { 'project-details': true }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.meta.section) {
      const element = document.getElementById(to.meta.section);
      if (element) {
        return { 
          el: `#${to.meta.section}`, 
          behavior: 'smooth',
          top: 0
        }
      }
    }
    return { top: 0 }
  }
})

export default router 